import { render, staticRenderFns } from "./moduleName.vue?vue&type=template&id=f80e4480&scoped=true&"
import script from "./moduleName.vue?vue&type=script&lang=js&"
export * from "./moduleName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80e4480",
  null
  
)

export default component.exports